module.exports = __webpack_public_path__ + "img/card-job-seeker-fair-default.1ba9690.png";